var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_c("pc-header"), _vm._m(0), _vm._m(1), _c("pc-footer")], 1)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrap" }, [
      _c("img", {
        attrs: { src: require("../../../assets/images/news/news-head-bg.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-wrap" }, [
      _c(
        "div",
        { staticClass: "title", staticStyle: { "font-size": "32px" } },
        [_vm._v(" 三亚启动入境游客移动支付便利化试点：无需开办本地银行卡 ")]
      ),
      _c("div", { staticClass: "time" }, [
        _vm._v("发布时间： 2021-12-9 08:39")
      ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "area", attrs: { id: "diycontenttop" } }, [
          _c(
            "div",
            {
              staticClass: "frame move-span cl frame-1",
              attrs: { id: "framegEN7e2" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "column frame-1-c",
                  attrs: { id: "framegEN7e2_left" }
                },
                [
                  _c("div", {
                    staticClass: "move-span temp",
                    attrs: { id: "framegEN7e2_left_temp" }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "block move-span",
                      attrs: { id: "portal_block_860" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "dxb_bc",
                          attrs: { id: "portal_block_860_content" }
                        },
                        [
                          _c("div", { staticClass: "portal_block_summary" }, [
                            _c("div", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.agilecentury.com/list/1/39/",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://paynews.net/data/attachment/common/cf/183713hka8e09ey8tmntg1.jpg",
                                      alt: "捷软世纪反洗钱",
                                      border: "0"
                                    }
                                  })
                                ]
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]),
        _c("p"),
        _c("p", [
          _vm._v(
            " 为有效提升入境游客移动支付服务体验，推动海南国际旅游消费中心建设，让境外游客移动支付消费“不见外”，12月3日下午，在三亚市人民政府、中国人民银行海口中心支行的指导下，由中国人民银行三亚市中心支行等单位主办的“三亚市大东海旅游区创建入境游客移动支付示范区启动仪式”在三亚市大东海广场举行。"
          )
        ]),
        _c("p", [
          _vm._v(
            " 即日起，境外游客到海南自贸港旅游消费，无须开办本地银行卡即可完成支付账户充值，只需智能手机扫一扫，便可像国内居民一样便利地使用移动支付进行日常消费。"
          )
        ]),
        _c("p", [
          _vm._v(
            " 据介绍，此次启动仪式为境外游客量身定制了多种移动支付便利化解决方案，实现了微信支付、数字人民币、银联境外钱包等多种移动支付模式的综合应用，境外游客可任意选择其中一种或多种支付方式进行注册使用。"
          )
        ]),
        _c("p", [
          _vm._v(
            " 如腾讯金融科技和光大银行海口分行为短期入境人士打造的微信支付模式，其操作非常简便，境外游客来琼入境时即可凭护照下载微信APP，通过 “Balance top up”小程序指引到全省21家光大银行网点办理外币兑换及支付账户充值，在不开立境内银行卡的前提下即可使用充值余额进行扫码消费，适用于零售购物、餐饮消费、景区购票、乘坐公交、共享骑行、网络约车等所有支持微信支付的交易场景。游客离境时可到省内光大银行任一网点办理剩余余额提取。目前微信支付模式已支持面向全体入境游客开通年支付限额为10000元人民币的钱包账户。 "
          )
        ]),
        _c("p", [
          _vm._v(
            " 下一步，三亚市人民政府、人民银行海口中心支行等将以海南自贸港及国际旅游消费中心建设为契机，适应新时代发展要求，组织更多职能部"
          )
        ]),
        _c("p"),
        _c("div", { staticClass: "clear" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }